export default /*@ngInject*/ function (ViewProductImportPageService) {
    var vm = this;

    vm.ViewProductImportPageService = ViewProductImportPageService;
    vm.getImportStatusClass = getImportStatusClass;

    function getImportStatusClass(status) {
        const classes = {
            "Completed": "toast-success",
            "InProgress": "toast-loading",
            "Error": "toast-error",
            "Skipped": "toast-warning"
        }

        return classes[status];
    }
}
